/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { powDependencies } from './dependenciesPow.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createDotPow } from '../../factoriesAny.js';
export var dotPowDependencies = {
  DenseMatrixDependencies,
  equalScalarDependencies,
  matrixDependencies,
  powDependencies,
  typedDependencies,
  createDotPow
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesDotPow.generated.js
// module id = 1352
// module chunks = 2